module.exports = __webpack_public_path__ + "static/media/stopwatch.c54d8638.svg";